'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ScreenReaderShortcuts = require('./components/ScreenReaderShortcuts.components');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ScreenReaderShortcuts).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-screen-reader-shortcuts/lib/index.js
// module id = 1344
// module chunks = 1